
const ACTIVE_RECORD_EXPR = '{deleted_at: {_is_null: true}}';

export {
    ACTIVE_RECORD_EXPR,
};
